import { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { PageRoutes } from "../constants/historyGaming";
import { useAppSelector } from "../components/hooks";
import { login, selectIsAuthenticated } from "@onmo/auth";
import { FEATURES } from "../types/theme";

const OnboardingLayout: React.FC = () => {
  const location = useLocation();
  const { theme } = useAppSelector((state) => state.theme);
  const hideOnboarding = theme?.hideFeature?.includes(FEATURES.onboarding) || false;
  const hideGuestPage = theme?.hideFeature?.includes(FEATURES.guestPage) || false;
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const at = (p: string) => location.pathname.startsWith(p);
  const hasOnboarded = localStorage.getItem("hasOnboarded") === "true";

  const shouldDirectLogin = !isAuthenticated && (hasOnboarded || hideOnboarding) && hideGuestPage;

  useEffect(() => {
    if (shouldDirectLogin) {
      login(window.location.origin);
    }
  }, [shouldDirectLogin]);

  if (!hideOnboarding && !hasOnboarded && !at(PageRoutes.Onboarding) && !isAuthenticated) {
    return <Navigate to={PageRoutes.Onboarding} replace />;
  }

  if ((hasOnboarded || hideOnboarding) && !hideGuestPage && !at(PageRoutes.Guest) && !isAuthenticated)
    return <Navigate to={PageRoutes.Guest} replace />;

  if (shouldDirectLogin) return null;
  return <Outlet />;
};

export default OnboardingLayout;
